// StandardChip.jsx
import React, { useState } from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

const capitalizeWords = (text = '') =>
  text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const StandardChip = ({
  label = '',
  selected,
  defaultSelected = false,
  showDelete = false,
  sx = {},
  onChange,
  captalise = true,
  height,
  size = 'medium', // small, medium
  ...rest
}) => {
  const theme = useTheme();
  const isControlled = selected !== undefined;
  const [internal, setInternal] = useState(defaultSelected);
  const active = isControlled ? selected : internal;

  const brownColor = '#995A00';
  const grayColor = theme.palette.grey[400];
  const blackColor = '#333333';

  const handleToggle = () => {
    if (!isControlled) setInternal(prev => !prev);
    onChange?.(!active);
  };

  return (
    <Chip
      label={captalise ? capitalizeWords(label) : label}
      onClick={handleToggle}
      onDelete={active && showDelete ? handleToggle : undefined}
      deleteIcon={active && showDelete ? <CloseIcon /> : undefined}
      sx={{
        color: active ? brownColor : blackColor,
        backgroundColor: 'transparent',
        outline: `1px solid ${active ? brownColor : grayColor}`,
        cursor: 'pointer',
        outlineOffset: '-1px',
        borderRadius: '8px !important',
        border: 'none',
        height: size === 'small' ? '28px' : '32px',
        padding: size === 'small' ? '2px 8px' : '4px 8px',
        fontSize:  size === 'small' ? '11px' : '13px',
        lineHeight: size === 'small' ? '20px' : '20px',
        fontWeight: 600,
        transition: 'all 0.2s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        '& .MuiChip-deleteIcon': {
          fontSize: size === 'small' ? '8px' : '13px',
          margin: 0,
        },
        '& .MuiChip-label': {
          paddingLeft: size === 'small' ? 0 : '8px',
          paddingRight: size === 'small' ? 0 : '8px',
        },
        
        ...sx,
      }}
      {...rest}
    />
  );
};

export default StandardChip;
